import { useMemo } from 'react';
import { useGetFormCategoriesQuery } from 'src/graphql';

export interface FormCategoryMap {
  'speak-up': string;
  'conflict-of-interest': string;
}

export const useFormCategories = () => {
  const { data, isLoading, error } = useGetFormCategoriesQuery(undefined, {
    staleTime: Infinity, // Cache forever (seeded data rarely changes)
    cacheTime: Infinity,
    retry: 3, // Retry 3 times on failure
    retryDelay: 1000,
  });

  const formCategoryMap: FormCategoryMap | null = useMemo(() => {
    if (!data?.formCategories?.formCategories) return null;

    const map: Partial<FormCategoryMap> = {};

    data.formCategories.formCategories.forEach((category) => {
      if (!category.id) return;

      if (category.categoryKey === 'speak_up') {
        map['speak-up'] = category.id;
      } else if (category.categoryKey === 'disclosure') {
        map['conflict-of-interest'] = category.id;
      }
    });

    // Only return if both categories are found
    if (map['speak-up'] && map['conflict-of-interest']) {
      return map as FormCategoryMap;
    }

    return null;
  }, [data]);

  const isReady = !isLoading && !error && formCategoryMap !== null;

  return {
    formCategoryMap,
    isLoading,
    error,
    isReady, // True only when data is successfully loaded
  };
};
